var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.413,
    height: 18.36,
    viewBox: "0 0 16.413 18.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(-0.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M7.862,0a6.415,6.415,0,0,0-1.8,4.227c0,2.755,1.877,4.194.741,6.178l-.137-.054C7.2,8.7,5.549,6.277,3.815,6.238A3.255,3.255,0,0,0,.388,9.5a2.821,2.821,0,0,0,3.04,2.59c-1.577-.825-1.616-2.815-.577-3.452C4.729,7.489,6.236,9.654,6.2,11.607c1.279-.472,3.53-3.9,3.53-7.312A6.705,6.705,0,0,0,7.862,0",
    fill: "#ff9e17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M17.131,27.007c.9-.559,1.62-2.429,1.887-3.538A3.485,3.485,0,0,1,21,17.7c2.278-.466,3.851,2,1.62,3.609,1.386.45,3.2-.994,3.168-2.648A3.1,3.1,0,0,0,21.8,15.617c-2.121.441-4.008,3.217-4.857,5.829a7.786,7.786,0,0,0,.184,5.563",
    transform: "translate(-8.989 -8.649)",
    fill: "#ff9e17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventWelcome);
export default __webpack_public_path__ + "static/media/eventWelcome.e4c7a4d58bd38703a7b83c8a662ce123.svg";
export { ForwardRef as ReactComponent };